const base = import.meta.env.BASE_URL;

export const LOGO = `${base}lovable-uploads/logo-200.png`;
export const CHURCH_PHOTO = `${base}lovable-uploads/church-optimized.jpg`;
